<script>
  import {onMount,onDestroy} from "svelte"
  import {basket} from "./basket-store"
  import Currency from "./currency.svelte"
  export let currency = "GBP"
  export let readonly = false
  
  const remove = (id)=> basket.remove(id)

  const updateQty = (id,e)=>{
    if(e.key=="Enter"){
      let qty = e.target.value
      if(qty > 0){
        basket.update({id, qty})
      }else{
        basket.remove(id)
      } 
    }
  }
</script>

<div>
  {#if $basket.items && $basket.items.length}
    <table class='table table-striped'>
      <thead> 
        <tr> 
          {#if !readonly}
            <th></th> 
          {/if}
          <th>Description</th> 
          <th>Qty</th> 
          <th>Item Price</th>
          <th>Line Total</th>
          <th>Line Tax</th>
        </tr>
      </thead>
      <tbody> 
        {#each  $basket.items as item}
          <tr>
            {#if !readonly}
              <td><button class="btn btn-warning" on:click={()=> remove(item.id)}>✕</button></td>  
            {/if}
            <td class="col-xs-6">
              {#if item.page && item.page.path}
                <a href={item.page.path}>{item.name}</a>
              {:else}
                {item.name}
              {/if}
            </td>
            {#if readonly}
              <td class="col-xs-1">{item.qty}</td>
            {:else}
              <td class="col-xs-1"><input class="form-control" bind:value={item.qty} on:keydown={(e)=> updateQty(item.id,e)}></td>
            {/if}
            <td><Currency currency={currency} value={item.price} /></td>
            <td><Currency currency={currency} value={item.total} /></td>
            <td><Currency currency={currency} value={item.totaltax} /></td>
          </tr>
        {/each}
      </tbody> 
      <tfoot> 
        <tr>
          <td colspan={readonly ? 2 : 3}></td> 
          <td><strong>Subtotals</strong></td>
          <td><strong><Currency currency={currency} value={$basket.subtotal} /></strong></td>
          <td><Currency currency={currency} value={$basket.tax} /></td> 
        </tr> 
        <tr class="totalline"> 
          <td colspan={readonly ? 3 : 4}></td> 
          <td><strong>Total</strong></td>
          <td><strong><Currency currency={currency} value={$basket.total} /></strong></td> 
        </tr> 
      </tfoot>
    </table>
  {:else}
    <p>Your basket is empty</p>
  {/if}
</div>

<style>
  .totalline{
    background:#eee;
  }
</style>